module.exports = __webpack_public_path__ + "img/3CH_PulseAlarm.5f1333be.png";